import {Layout, Menu} from "antd";
import React, {useState} from 'react';
import {Link, Outlet} from "react-router-dom";

const {Content, Footer, Header} = Layout;

const menu = [
    {
        label: (<Link to="/mail">Mail</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    },
    {
        label: (<Link to="/image">Image</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    },
    {
        label: (<Link to="/qr-code">QR code</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    },
    {
        label: (<Link to="/link">Link</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    },
    {
        label: (<Link to="/reddit">Reddit</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    },
    {
        label: (<Link to="/tiktok">Tiktok</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    },
    {
        label: (<Link to="/login">Logout</Link>),
        key: Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
    }
];

export function LayoutMaster() {
    const [current, setCurrent] = useState('1');
    const onClick = (e) => {
        setCurrent(e.key);
    };

    return (
        <Layout>
            <Header className="site-layout-background" style={{position: 'fixed', zIndex: 1000, width: '100%'}}>
                <div className="logo"/>
                <Menu
                    onClick={onClick}
                    selectedKeys={[current]}
                    theme="light"
                    mode="horizontal"
                    defaultSelectedKeys={['1']}
                    items={menu.map((_, index) => ({
                        key: _.key,
                        label: _.label,
                    }))}
                />
            </Header>
            <Content className="site-layout"
                     style={{padding: '0 50px', marginTop: 80, minHeight: 'calc(100vh - 130px)'}}>
                <Outlet/>
            </Content>
            <Footer style={{textAlign: 'center'}}>Vudx</Footer>
        </Layout>
    )
}
